import store from "../../store";
import export_customers from "./export_customers.vue";

window.EXPORT_USERS =  new Vue({
    store,
    el: 'div#export_block',
    name : "EXPORT_BLOCK",
    data () {
        return {
        }
    },
    created () {

    },
    components : {
        export_customers
    }
});
